module.exports = __webpack_public_path__ + "static/img/6.38a6b12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/6.png
// module id = rZpg
// module chunks = 0